import React from 'react';
import { Link } from "react-scroll";
import Button from 'react-bootstrap/Button';

// import { Container } from './styles';

function Quimico({patter3, quimico1, newAttendance, arrowUp, arrowDown}) {
    return (
        <div  id="quimico">
            <div className="bodySolucoes sumir" style={{backgroundColor: 'var(--main-white-color)', width: "100%", marginBottom: 50, overflowY: "hidden", overflowX: 'hidden', position: 'relative'}}>
                <img
                    src={patter3}
                    alt="patter3"
                    className='patter3'
                />
                <div
                style={{
                    display: "flex",
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: 120,
                    lineHeight: 1,
                }}>
                    <p 
                    style={{
                        color: "var(--main-bg-color)", 
                        fontSize: 34, 
                        fontWeight: 700,
                        margin: 20,
                        marginLeft: 90
                    }}>
                        <span style={{fontSize: 20, color: 'var(--main-secondy)'}}>COLETA DE </span><br></br>
                        RESÍDUO QUÍMICO
                    </p>
                </div>
                <div className="row" style={{width: "100%"}}>
                    <div className='col-12 col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6' 
                    style={{
                        display: "flex",
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        marginTop: 20,
                        position: 'relative'
                    }}>
                        <Link
                            activeClass="active"
                            to="biologico"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="buttonUpL"
                            containerId="conteiner"
                            >
                            <img
                                src={arrowUp}
                                alt="Seta pra cima"
                            />
                        </Link>
                        <Link
                            activeClass="active"
                            to="pgrss"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="buttonDownL"
                            containerId="conteiner"
                            >
                            <img
                                src={arrowDown}
                                alt="Seta pra baixo"
                            />
                        </Link>
                        <img
                            src={quimico1}
                            alt="Imagem Residuo Extraordinario"
                            style={{width: "90%", paddingLeft: 68}}
                        />
                    </div>
                    <div className='col-12 col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6'
                    style={{
                        display: "flex",
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        flexDirection: 'column'
                    }}>
                        <div className="row" style={{
                            display: "flex",
                            alignItems: 'center',
                            padding: 40,
                            paddingRight: 120
                        }}>
                            <p 
                            className='titleText'>
                                Saiba agora todos os detalhes da nossa coleta.
                            </p>
                            <p 
                            className='subTitleText'>
                                Resíduos que apresentam risco à saúde pública ou ao meio ambiente, dependendo de suas características de inflamabilidade, corrosividade, reatividade e toxicidade!<br></br><br></br>
                                Alguns dos exemplos destes materiais são: pilhas, baterias, produtos químicos de limpeza e de indústriais, como graxas.<br></br><br></br>
                                Nossa coleta envolve veículo especializado, com acondicionamento de acordo com a legislação vigente. Logo após, destinamos aos locais especializados para correto descarte.
                            </p>
                            <div style={{width: '100%', display: "flex", alignItems: 'center', justifyContent: 'center', marginTop: 30}}>
                                <Button style={{
                                    boxShadow: "0px 15.3171px 15.3171px rgba(0, 0, 0, 0.25)",
                                    backgroundColor: "var(--main-bg-color)",
                                    border: 0,
                                }} 
                                variant="secondary"
                                onClick={() => newAttendance('Olá grupo Urbam, solicito orçamento sobre o Resíduo Químico')}
                                >
                                    ORÇAMENTO | RESÍDUO QUÍMICO
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bodySolucoes mostrar" style={{backgroundColor: 'var(--main-white-color)', width: "100%", margin: 0, overflowY: "hidden", overflowX: 'hidden', position: 'relative'}}>
                <div
                style={{
                    display: "flex",
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    lineHeight: 1,
                    height: 160,
                }}>
                    <p 
                    style={{
                        color: "var(--main-bg-color)", 
                        fontSize: 34, 
                        fontWeight: 700,
                        margin: 20,
                        marginLeft: 90
                    }}>
                        <span style={{fontSize: 20, color: 'var(--main-secondy)'}}>COLETA DE </span><br></br> 
                        RESÍDUO QUÍMICO <br></br>
                    </p>
                </div>
                <div className="row" style={{width: "100%"}}>
                    <div className='col-12 col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6'
                    style={{
                        display: "flex",
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'relative'
                    }}>
                        <Link
                            activeClass="active"
                            to="biologico"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="buttonUpL"
                            containerId="conteiner"
                            >
                            <img
                                src={arrowUp}
                                alt="Seta pra cima"
                            />
                        </Link>
                        <Link
                            activeClass="active"
                            to="pgrss"
                            spy={true}
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="buttonDownL"
                            containerId="conteiner"
                            >
                            <img
                                src={arrowDown}
                                alt="Seta pra baixo"
                            />
                        </Link>
                        <img
                        src={quimico1}
                        alt="Imagem Residuo Quimico"
                        style={{width: "94%", paddingLeft: 68}}
                        />
                        
                    </div>
                    <div className='col-12 col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6'
                        style={{
                            display: "flex",
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                            flexDirection: 'column'
                        }}>
                        <div className="row" style={{
                            display: "flex",
                            alignItems: 'center',
                            padding: 40,
                            paddingLeft: 60 
                        }}>
                            <p 
                            className='titleText'>
                                Saiba agora todos os detalhes da nossa coleta.
                            </p>
                            <p 
                            className='subTitleText' style={{paddingRight: 30}}>
                                Resíduos que apresentam risco à saúde pública ou ao meio ambiente, dependendo de suas características de inflamabilidade, corrosividade, reatividade e toxicidade!<br></br><br></br>
                                Alguns dos exemplos destes materiais são: pilhas, baterias, produtos químicos de limpeza e de indústriais, como graxas.<br></br><br></br>
                                Nossa coleta envolve veículo especializado, com acondicionamento de acordo com a legislação vigente. Logo após, destinamos aos locais especializados para correto descarte.
                            </p>
                            <div style={{width: '100%', display: "flex", alignItems: 'center', justifyContent: 'center', marginTop: 30}}>
                                <Button style={{
                                    boxShadow: "0px 15.3171px 15.3171px rgba(0, 0, 0, 0.25)",
                                    backgroundColor: "var(--main-bg-color)",
                                    border: 0,
                                }} 
                                variant="secondary"
                                onClick={() => newAttendance('Olá grupo Urbam, solicito orçamento sobre o Resíduo Químico')}
                                >
                                    RESÍDUO QUÍMICO
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Quimico;